// import axios from 'axios'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const MDM_GETING_USERS = 'MDM_GETING_USERS'
export const MDM_RECEIVED_USERS = 'MDM_RECEIVED_USERS'
export const MDM_RESET_FETCHED = 'MDM_RESET_FETCHED'

const getUsers = () => ({
  type: MDM_GETING_USERS,
})

const receiveUsers = users => ({
  type: MDM_RECEIVED_USERS,
  users,
})

export const resetFetched = () => ({
  type: MDM_RESET_FETCHED,
})

export function loadMdmUsers(query, currentUserId, onlyPartners = false, onlyActive = false) {
  return (dispatch) => {
    dispatch(getUsers())
    agent.MDM.getMdmUsers(query, currentUserId, onlyPartners, onlyActive).then((response) => {
      dispatch(receiveUsers(response))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <loadMdmUsers>: ', description, error)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/mdm.js